import request from '@/utils/request'

export function getWxSign(params) {
  return request({
    url: '/en/c/wxShare/getSign',
    method: 'get',
    params,
    customize: true,
    prefix: import.meta.env.VITE_BASE_INTERACT_URL as string
  })
}

export function getWxSignV2(params) {
  return request({
    url: '/en/c/v2/wxShare/getSign',
    method: 'get',
    params,
    customize: true,
    prefix: import.meta.env.VITE_BASE_INTERACT_URL as string
  })
}

export function getSuggestDetail(data) {
  return request({
    url: '/recommend/en/c/list',
    method: 'post',
    data,
    headers: {
      'plat': 'phone'
    },
    prefix: import.meta.env.VITE_BASE_BFF_URL as string,
  })
}


